/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum IconEnum {
    RequestAccepted = 'REQUEST_ACCEPTED',
    RequestOutgoing = 'REQUEST_OUTGOING',
    RequestIncoming = 'REQUEST_INCOMING',
    RequestDeclined = 'REQUEST_DECLINED',
    RequestCancelledIncoming = 'REQUEST_CANCELLED_INCOMING',
    RequestCancelledOutgoing = 'REQUEST_CANCELLED_OUTGOING',
    HasChanges = 'HAS_CHANGES'
}



